import { useState, useEffect, useCallback } from 'react';
import { Activity, Gavel } from 'lucide-react';
import { adminApi } from '@/utils/api';

export const AuctionMonitor = () => {
    const [auctions, setAuctions] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchAuctions = useCallback(async () => {
        try {
            const res = await adminApi.getAuctionMonitor();
            const data = await res.json();
            if (data.success) setAuctions(data.auctions);
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    }, []);

    useEffect(() => {
        fetchAuctions();
        const interval = setInterval(fetchAuctions, 10000);
        return () => clearInterval(interval);
    }, [fetchAuctions]);

    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between mb-2">
                <h3 className="text-[10px] font-black uppercase tracking-[0.2em] text-blue-400/60 flex items-center gap-2">
                    <Activity size={10} className="animate-pulse" /> Live Auction Monitor
                </h3>
            </div>
            {loading ? <div className="p-4 bg-white/5 rounded-xl animate-pulse h-20" /> : (
                <div className="grid gap-2">
                    {auctions.map(a => (
                        <div key={a.auction_id} className="bg-white/5 border border-white/5 p-3 rounded-xl flex items-center justify-between group hover:bg-white/10 transition-all">
                            <div className="flex items-center gap-3">
                                <div className="w-8 h-8 rounded-lg bg-blue-500/20 flex items-center justify-center text-blue-400 border border-blue-500/30 font-bold text-xs uppercase">
                                    <Gavel size={14} />
                                </div>
                                <div>
                                    <div className="text-xs font-bold text-white flex items-center gap-2">
                                        {a.card_name}
                                        <span className="text-[9px] text-[#3390EC] font-mono tracking-tighter opacity-50">#{a.auction_id}</span>
                                    </div>
                                    <div className="text-[10px] text-white/40 flex items-center gap-2">by <span className="text-white/60">@{a.seller_name}</span></div>
                                </div>
                            </div>
                            <div className="text-right">
                                <div className="text-sm font-black text-blue-400 font-mono tracking-tight">{a.current_price} <span className="text-[9px] opacity-60">GRAM</span></div>
                                <div className="flex items-center justify-end gap-2 mt-0.5">
                                    <div className="text-[9px] text-white/30 uppercase font-black">{a.bid_count} Bids</div>
                                    <div className={`text-[9px] font-black px-1.5 py-0.5 rounded ${a.seconds_left < 300 ? 'bg-red-500/20 text-red-500' : 'bg-green-500/10 text-green-500'}`}>
                                        {Math.floor(a.seconds_left / 60)}m {a.seconds_left % 60}s
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {auctions.length === 0 && <div className="p-8 text-center text-white/20 text-xs border border-dashed border-white/5 rounded-2xl">No active auctions to monitor.</div>}
                </div>
            )}
        </div>
    );
};
